import { Component } from '@angular/core';

@Component({
	selector: 'app-browser-compatibility-error',
	templateUrl: './browser-compatibility-error.component.html',
	styleUrls: ['./browser-compatibility-error.component.scss'],
})
export class BrowserCompatibilityErrorComponent {}
